import React from 'react';

export default class ExportCSVButton extends React.Component {
  constructor(props) {
    super(props)
    this.exportCSV = this.exportCSV.bind(this);
  };

  render() {
    return (
      <a className="export-link" onClick={this.exportCSV}>
        {I18n.t("export_to_csv")}
      </a>
    )
	}

  exportCSV() {
    var self = this;
    self.props.onChangeLoadingSpinner(true);
    var data = {
      order_by: self.props.order_by,
      search_columns: self.props.searchColumns,
      date: this.props.audit_date,
    };

    var href = self.props.exportCSVEndpoint;
      
    if (self.props.action_params) {
      if (href.indexOf('?') == -1) {
        href = href + '?' + self.props.action_params;
      } else {
        href = href + '&' + self.props.action_params;
      }
    }

    $.ajax({
      method: "POST",
      url: href,
      data: data,
    })
    .done(() => {      
      if (parent && parent.refresh_data) {
        parent.refresh_data(I18n.t('csv_will_be_emailed'));
      }
      self.props.onChangeLoadingSpinner(false)
    })
  }
};